module.exports = __webpack_public_path__ + "img/simple_chibby.c126ecb2.jpg";